import {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import refreshToken from './refreshToken';

export interface ConfigComRetentativa extends AxiosRequestConfig {
  jaTentouRenovarToken?: boolean;
}

const URLS_SEM_RENOVACAO = ['auth/login', 'auth/refresh-token'];

// Tenta renovar o token antes de deslogar: um 401 pode ser sessão realmente expirada, ou só
// um soluço passageiro do lado do servidor — nesses casos o refresh token (que ainda é
// válido) resolve sem o usuário perceber. Se o refresh também falhar, quem limpa a sessão e
// redireciona é o próprio refreshToken(); não duplicamos essa limpeza aqui.
// `auth/login` e `auth/refresh-token` ficam de fora: um 401 neles é uma decisão própria
// (credencial errada, refresh token expirado), não algo que renovar resolve.
export function criarInterceptorDeRenovacao(cliente: AxiosInstance) {
  return async function tratarErro401(
    error: AxiosError & { config: ConfigComRetentativa },
  ): Promise<AxiosResponse> {
    const podeRenovar =
      error?.response?.status === 401 &&
      !error.config?.jaTentouRenovarToken &&
      !URLS_SEM_RENOVACAO.includes(error.config?.url ?? '');

    if (!podeRenovar) {
      return Promise.reject(error);
    }

    try {
      const newAccessToken = await refreshToken();
      const configComNovoToken: ConfigComRetentativa = {
        ...error.config,
        headers: {
          ...error.config.headers,
          authorization: `Bearer ${newAccessToken}`,
        },
        jaTentouRenovarToken: true,
      };

      return cliente.request(configComNovoToken);
    } catch {
      return Promise.reject(error);
    }
  };
}
